import React, { useState, useEffect, useMemo } from 'react';
import Grid from '@mui/material/Grid';
import AddIcon from '@mui/icons-material/Add';
import useSessionVariableStore, { getSessionVariableStore } from './useSessionVariableStore';
import useProjectStore from '../ProjectCanvas/useProjectStore';
import RenderSessionVariableItem from './RenderSessionVariableItem';
import { getCurrentTime } from '../../utils/getCurrentTime';
import { send_component_save_request, send_request } from '../../utils/Request';
import { injectMetadataFields } from '../../utils/buildComponentSavePayload';
import { IndividualComponentLoader } from '../../utils/ComponentLoadingSkeleton';

const SessionVariablesTemplate = (props) => {
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [description, setDescription] = useState(null);
  const [status, setStatus] = useState(null);

  const store = useMemo(() => getSessionVariableStore(props.component_id), [props.component_id]);

  const data = store((s) => s.data);
  const sessionVariableData = data.variables || [];

  const keyAuto = () =>
    'session_data' + (Math.floor(Math.random() * 90000000) + 10000).toString();

  const addEmptySessionVariable = () => {
    const current = [...(store.getState().data.variables || [])];
    current.push({
      key: keyAuto(),
      type: 'text',
      value: null,
    });
    store.getState().setSessionVariableData(current);
  };

  useEffect(() => {
    if (props.component_id === undefined) return;

    if (store.getState().loaded) {
      props.onComponentNameChanged(store.getState().name);
      props.onLastModifiedChanged(store.getState().lastModified);
      setLoading(false);
      props.setChildTemplateLoaded(true);
      return;
    }

    setLoading(true);
    send_request(
      `project-service/project/component/query/${props.component_id}/at-version/${props.version}`,
      '',
      {}
    )
      .then((response) => {
        if (response && response.data) {
          const { components } = response.data;
          if (components) {
            store.getState().setSessionVariables(components[0]);
            store.setState({ loaded: true });
            props.onComponentDescriptionChanged(components[0].description);
            props.onComponentNameChanged(store.getState().name);
            props.onLastModifiedChanged(store.getState().lastModified);
          }
        }

        setLoading(false);
        props.setChildTemplateLoaded(true);
      })
      .catch((err) => {
        throw Error(err.message);
      });
  }, []);

  if (!loading) {
    return (
      <Grid>
        {sessionVariableData.map((aData, index) => (
          <RenderSessionVariableItem
            key={index}
            aData={aData}
            index={index}
            sessionVariableData={sessionVariableData}
            availablePlaceholders={props.availablePlaceholders}
            onPlaceholderSelected={props.onPlaceholderSelected}
            setSessionVariableData={(updatedData) => {
              store.getState().setSessionVariableData(updatedData);
            }}
            component={'session_variable_record'}
            componentStore={store}
          />
        ))}

        <Grid item xs={12}>
          <div className="new-session-variable">
            <div
              className="query-database-add-data"
              onClick={() => {
                addEmptySessionVariable();
              }}
            >
              <AddIcon /> Add Session variable
            </div>
          </div>
        </Grid>
      </Grid>
    );
  } else return <IndividualComponentLoader />;
};

export default SessionVariablesTemplate;
